import { httpApi } from '@app/api/http.api';
import { IFile, IFileInput } from '@app/interfaces/file';
import { FileUploadRequest, SearchQueryResponse, UpdateImgResponse } from '@app/interfaces/interfaces';
import { QueryRequest } from '@app/store/slices/userSlice';
import { jsonToFormData } from '@app/utils/utils';

const baseSlug = '/files';

export const uploadFile = (filePayload: FileUploadRequest, isGuest = false): Promise<UpdateImgResponse> => {
  const formData = new FormData();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formData.append('file', filePayload?.file as any);
  formData.append('entity', filePayload.entity as string);
  formData.append('entityId', filePayload.entityId as string);
  return httpApi
    .post<UpdateImgResponse>(`${baseSlug}/${isGuest ? 'guestUpload' : 'upload'}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(({ data }) => data)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const uploadFiles = (filePayload: FileUploadRequest): Promise<UpdateImgResponse[]> => {
  const formData = jsonToFormData(filePayload);
  return httpApi
    .post<UpdateImgResponse[]>(`/files/uploadMultiple`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(({ data }) => data)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getAWSSignedURL = async (id: string): Promise<string | null> => {
  try {
    const { data } = await httpApi.get<string>(`${baseSlug}/signedUrl/${id}`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const getFileWithSignedUrl = async (id: string): Promise<IFile | null> => {
  try {
    const { data } = await httpApi.get<IFile>(`${baseSlug}/fileWithSignedUrl/${id}`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

const sendFormDataRequest = async <T>(url: string, method: 'post' | 'patch', payload: Partial<IFile>): Promise<T> => {
  try {
    const formData = jsonToFormData(payload);
    const { data } = await httpApi[method]<T>(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const createFile = async (payload: Partial<IFileInput>): Promise<IFile> => {
  return sendFormDataRequest<IFile>(`${baseSlug}`, 'post', payload);
};

export const updateFile = async (id: string, payload: Partial<IFileInput>): Promise<IFile> => {
  return sendFormDataRequest<IFile>(`${baseSlug}/${id}`, 'patch', payload);
};

export const deleteFile = async (id: string): Promise<undefined> => {
  try {
    const { data } = await httpApi.delete<undefined>(`${baseSlug}/${id}`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const getFileListWithPagination = async (queryPayload: QueryRequest): Promise<SearchQueryResponse> => {
  try {
    const { data } = await httpApi.get<SearchQueryResponse>(
      `${baseSlug}/queryFilesWithPagination?${new URLSearchParams(queryPayload as Record<string, string>).toString()}`,
    );
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const getFile = async (id: string): Promise<IFile | null> => {
  try {
    const { data } = await httpApi.get<IFile>(`${baseSlug}/${id}`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};
